


































import { computed, defineComponent } from "@vue/composition-api";
import { isAudioFile } from "@/lib/fileHelpers";
import { AttachmentFile } from "@/types";
import AudioPlayerController from "@/components/AudioPlayerController";
import BaseThumbnailButton from "@/components/BaseThumbnailButton";
import MediaPreview from "@/components/MediaPreview";
import AudioAttachmentPlayerView from "@/components/MessageSendWithAttachment/components/AudioAttachmentPlayerView.vue";

export default defineComponent({
  name: "AttachmentFilesPreview",
  components: {
    AudioAttachmentPlayerView,
    AudioPlayerController,
    BaseThumbnailButton,
    MediaPreview,
  },
  props: {
    files: { type: Array as () => AttachmentFile[], default: [] },
    allowPublicFiles: { type: Boolean, default: false },
    allowedPublicFilesCount: { type: Number, default: 0 },
  },
  setup(props) {
    const filesWithoutAudio = computed<AttachmentFile[]>(() => props.files.filter(f => !isAudioFile(f)));
    const audioFiles = computed<AttachmentFile[]>(() => props.files.filter(f => isAudioFile(f)));
    const isShowCover = computed<boolean>(() => {
      return props.allowPublicFiles && props.allowedPublicFilesCount > 0 && audioFiles.value.length === 0;
    });

    return {
      audioFiles,
      isShowCover,
      filesWithoutAudio,
    };
  },
});
